module.exports = __webpack_public_path__ + "static/img/grade_13.a4b3f9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/oralT/img/grade_13.png
// module id = mXmb
// module chunks = 89